<div class="modal-header">
    <h3 class="modal-title" id="error-message-modal-title-text" translate="ERROR_MESSAGE_MODAL_TITLE"></h3>
    <span class="close" (click)="close()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <p class="user-select-auto">{{ errorData?.customErrorDetails?.message }}</p>
    <p class="user-select-auto">
        {{ errorData?.customErrorDetails?.action }}
        @if (supportId) {
            <br />
            <span
                class="text-danger fw-bold"
                style="cursor: pointer"
                (click)="copyOperationIdQuery()"
                title="Click to copy Azure Log query"
            >
                Support ID: {{ supportId }}
                <fa-icon [icon]="faCopy" class="ms-1" size="sm"></fa-icon>
            </span>
        }
    </p>

    <div class="d-flex justify-content-between align-items-center">
        <button
            type="button"
            class="fs-6 btn btn-link p-0"
            (click)="toggleDetailsExpansion()"
            [attr.aria-label]="'ERROR_MESSAGE_MODAL_ACTION_TO_SHOW_DETAILS' | translate"
        >
            <span class="pe-2" translate="ERROR_MESSAGE_MODAL_ACTION_TO_SHOW_DETAILS"></span>
            <fa-icon [icon]="isDetailExpanded ? faChevronUp : faChevronDown"></fa-icon>
        </button>
        <button
            type="button"
            class="fs-6 btn btn-link p-0 text-decoration-none"
            style="color: var(--bs-body-color)"
            (click)="copyEntireError()"
            title="Click to copy entire error"
        >
            <span class="pe-2">Copy error</span>
            <fa-icon [icon]="faCopy"></fa-icon>
        </button>
    </div>
    @if (isDetailExpanded) {
        @if (errorData?.rawError; as raw) {
            <div class="detail-section p-3 mt-2 overflow-auto border border-secondary border-1">
                <div class="mb-1">
                    <strong>{{ raw.name }}</strong>
                    for route:
                </div>
                <div class="mb-1 text-break">
                    <code>{{ raw.url }}</code>
                </div>
                <div class="mb-2">
                    <strong>Status:</strong>
                    {{ raw.status }} {{ raw.statusText }}
                </div>
                <hr />
                <pre class="mt-2 text-break" style="white-space: pre-wrap">{{ formattedError }}</pre>
            </div>
        }
    }
</div>
<div class="modal-footer d-flex">
    <div
        class="d-flex align-items-center"
        *ngrxLet="pendingRequestCount$; let count"
        #tooltip="bs-tooltip"
        [placement]="'right'"
        [tooltip]="'ERROR_MESSAGE_MODAL_DETAILS_PENDING_REQUEST_COUNT_TOOLTIP' | translate"
    >
        @if (count > 0) {
            <fa-icon [icon]="faUpload" size="lg" class="text-danger"></fa-icon>
            <span class="badge rounded-pill bg-danger">{{ count }}</span>
        }
    </div>
    <span class="ms-auto">
        <button
            class="btn btn-primary me-2"
            type="button"
            (click)="reportAnIssue()"
            [attr.aria-label]="'ERROR_MESSAGE_MODAL_ACTION_TO_REPORT_AN_ISSUE' | translate"
        >
            <span translate="ERROR_MESSAGE_MODAL_ACTION_TO_REPORT_AN_ISSUE"></span>
        </button>
        <button
            class="btn btn-primary"
            type="button"
            (click)="close()"
            [attr.aria-label]="'ERROR_MESSAGE_MODAL_ACTION_TO_CONTINUE_WORK' | translate"
        >
            <span translate="ERROR_MESSAGE_MODAL_ACTION_TO_CONTINUE_WORK"></span>
        </button>
    </span>
</div>
